module.exports = __webpack_public_path__ + "img/driver_default.6a93f3eb.jpg";